export var SYSTEM_EVENTS = {
    init: 'init',
};
export var SHARED_EVENTS = {
    PAGE_VIEW: 'pageview',
    PERFORMANCE: 'Supplier_Basic_Front_Performance',
};
